<template>
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-layout wrap>
          <v-flex xs12>
            <v-text-field
              v-model="date"
              :label="label"
              readonly
              v-bind="attrs"
              v-on="on"
              outlined
              dense
              hide-details
            />
          </v-flex>
          <v-flex xs12>
            <small>{{info}} | {{prepareYears(date)}}</small>
          </v-flex>
        </v-layout>
      </template>
      <v-date-picker
        v-model="date"
        :active-picker.sync="activePicker"
        :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
        min="1950-01-01"
        @change="save"
      />
    </v-menu>
</template>
<script>
import utils from '@/services/utils'
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    onChange: {
      type: Function,
      default: null,
    },
    data: {
      type: String,
      default: null,
    },
    min: {
      type: Number,
      default: null,
    },
    max: {
      type: Number,
      default:null,
    },
  },
  data: () => ({
    activePicker: null,
    date: null,
    menu: false,
    info: ''
  }),
  watch: {
    data () {
      this.prepareDate()
    },
    menu (val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    },
  },
  mounted () {
    this.prepareDate()
  },
  methods: {
    prepareMinMax (min, max) {
      let result = ''
      if (this.min) result += ` Min: ${utils.getYearsByDays(this.min)}`
      if (this.max) result += ` Max: ${utils.getYearsByDays(this.max)}`
      this.info = result
    },
    prepareYears (v){
      if (!v) return
      const diff = new Date() - new Date(v)
      return utils.getYearsByDays(diff/(1000*60*60*24))
    },
    prepareDate () {
      if (this.data) this.date = this.data
      this.prepareMinMax()
    },
    save (date) {
      this.$refs.menu.save(date)
      if (this.onChange) this.onChange(date)
    },
  },
}
</script>


